const globalConfig = {};
let globalConfigIsFrozen = false;
function freezeGlobalConfig() {
  globalConfigIsFrozen = true;
}
export {
  freezeGlobalConfig,
  globalConfig,
  globalConfigIsFrozen
};
//# sourceMappingURL=instance-config.es.js.map
